import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const problems = ['Llevás el registro de tus pacientes en cuadernos desorganizados o papeles sueltos', 'Perdés horas de tu tiempo libre redactando informes desde cero para cada paciente', 'Las obras sociales te rechazan o demoran los pagos por falta de documentación adecuada', 'No tenés un respaldo legal sólido de las sesiones y la evolución de tus tratamientos', 'Te cuesta mantener un seguimiento objetivo del progreso real de cada paciente', 'Sentís que la imagen administrativa de tu consultorio no refleja tu nivel profesional'];
export function ProblemAgitation() {
  return <section className="py-14 md:py-24 bg-brand-dark text-white" data-id="element-265">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="text-center mb-10 md:mb-16" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-268">
            ¿Te está pasando esto?
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto rounded-full" data-id="element-269"></div>
        </div>

        <div className="space-y-3 md:space-y-6 mb-10 md:mb-16" data-id="element-270">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 bg-slate-800/50 p-4 md:p-6 rounded-xl border border-slate-700/50" data-id="element-271">
              <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-272" />
              <p className="text-sm md:text-lg text-slate-300" data-id="element-273">{problem}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}